// extracted by mini-css-extract-plugin
export default {"zoomModal":"X0-z","image":"Y0-z","button":"Z0-z","isOverlayShown":"_0-z"};